import React from 'react';
import SingleValueRadial from '@splunk/dashboard-visualizations/SingleValueRadial';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import RadialBasicCode from '!!raw-loader!./examples/RadialBasic';
import RadialFieldFooCode from '!!raw-loader!./examples/RadialFieldFoo';
import RadialFieldBarCode from '!!raw-loader!./examples/RadialFieldBar';
import RadialPositionBelowCode from '!!raw-loader!./examples/RadialPositionBelow';
import RadialPositionOutsideCode from '!!raw-loader!./examples/RadialPositionOutside';
import RadialTrendModePercentCode from '!!raw-loader!./examples/RadialTrendModePercent';
import RadialColorCustomizationCode from '!!raw-loader!./examples/RadialColorCustomization';
import RadialMajorValueLargeCode from '!!raw-loader!./examples/RadialMajorValueLarge';
import RadialTrendValueLargeCode from '!!raw-loader!./examples/RadialTrendValueLarge';
import RadialColorDataSeriesCode from '!!raw-loader!./examples/RadialColorDataSeries';
import BackgroundColorWhiteCode from '!!raw-loader!./examples/BackgroundColorWhite';
import EncodingColumnIndexCode from '!!raw-loader!./examples/EncodingColumnIndex';
import EncodingFormatCode from '!!raw-loader!./examples/EncodingFormat';
import EncodingFormatColumnIndexCode from '!!raw-loader!./examples/EncodingFormatColumnIndex';

import RadialBasicExample from './examples/RadialBasic';
import RadialFieldFooExample from './examples/RadialFieldFoo';
import RadialFieldBarExample from './examples/RadialFieldBar';
import RadialPositionBelowExample from './examples/RadialPositionBelow';
import RadialPositionOutsideExample from './examples/RadialPositionOutside';
import RadialTrendModePercentExample from './examples/RadialTrendModePercent';
import RadialColorCustomizationExample from './examples/RadialColorCustomization';
import RadialMajorValueLargeExample from './examples/RadialMajorValueLarge';
import RadialTrendValueLargeExample from './examples/RadialTrendValueLarge';
import RadialColorDataSeriesExample from './examples/RadialColorDataSeries';
import BackgroundColorWhiteExample from './examples/BackgroundColorWhite';
import EncodingColumnIndexExample from './examples/EncodingColumnIndex';
import EncodingFormatExample from './examples/EncodingFormat';
import EncodingFormatColumnIndexExample from './examples/EncodingFormatColumnIndex';

import doc from './definition';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Dashboard Single Value Radial"
        description="Wrapper around the Radial visualization that maps a datasource to values to display"
        examplesSection={[
            <DocExample
                title="Basic Radial Graph"
                key="basic"
                code={RadialBasicCode}
                example={RadialBasicExample}
            />,
            <DocExample
                title="Basic Radial Graph. Background Color is white."
                key="backgroundcolorwhite"
                code={BackgroundColorWhiteCode}
                example={BackgroundColorWhiteExample}
            />,
            <DocExample
                title="Radial Graph, Encoding Field is foo"
                key="radialfieldfoo"
                code={RadialFieldFooCode}
                example={RadialFieldFooExample}
            />,
            <DocExample
                title="Radial Graph, Encoding Field is bar"
                key="radialfieldbar"
                code={RadialFieldBarCode}
                example={RadialFieldBarExample}
            />,
            <DocExample
                title="Radial Graph, Trend Indicator Position is below"
                key="radialpositionbelow"
                code={RadialPositionBelowCode}
                example={RadialPositionBelowExample}
            />,
            <DocExample
                title="Radial Graph, Trend Indicator Position is outside"
                key="radialpositionoutside"
                code={RadialPositionOutsideCode}
                example={RadialPositionOutsideExample}
            />,
            <DocExample
                title="Radial Graph, Trend Display Mode is percent"
                key="radialtrendmodepercent"
                code={RadialTrendModePercentCode}
                example={RadialTrendModePercentExample}
            />,
            <DocExample
                title="Radial Graph Stroke Color is flamenco, Radial Background Color is valencia"
                key="radialcolorcustom"
                code={RadialColorCustomizationCode}
                example={RadialColorCustomizationExample}
            />,
            <DocExample
                title="Radial Graph, Major Value is large, Trend Value is displayed below"
                key="radialmajorvaluelarge"
                code={RadialMajorValueLargeCode}
                example={RadialMajorValueLargeExample}
            />,
            <DocExample
                title="Radial Graph, Trend Value is large, Trend Value is displayed below"
                key="radialtrendvaluelarge"
                code={RadialTrendValueLargeCode}
                example={RadialTrendValueLargeExample}
            />,
            <DocExample
                title="Radial Graph color data series specified"
                key="radialcolordataseries"
                code={RadialColorDataSeriesCode}
                example={RadialColorDataSeriesExample}
            />,
            <DocExample
                title="Encoding column index specified"
                key="encodingcolumnindex"
                code={EncodingColumnIndexCode}
                example={EncodingColumnIndexExample}
            />,
            <DocExample
                title="Encoding format specified"
                key="encodingformat"
                code={EncodingFormatCode}
                example={EncodingFormatExample}
            />,
            <DocExample
                title="Encoding format column index specified"
                key="encodingformatcolumnindex"
                code={EncodingFormatColumnIndexCode}
                example={EncodingFormatColumnIndexExample}
            />,
        ]}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
        optionSection={<OptionsDoc options={optionsSchema} />}
        eventSection={
            <EventsDoc
                events={doc.events}
                Visualization={SingleValueRadial}
                options={{
                    trendIndicatorPosition: 'below',
                }}
                encoding={{}}
                dsState={{
                    primary: {
                        data: {
                            columns: [
                                ['5', '12', '46', '23', '51', '115', '63', '88'],
                                [
                                    '2018-08-19T00:00:00.000+00:00',
                                    '2018-08-20T00:00:00.000+00:00',
                                    '2018-08-21T00:00:00.000+00:00',
                                    '2018-08-22T00:00:00.000+00:00',
                                    '2018-08-23T00:00:00.000+00:00',
                                    '2018-08-24T00:00:00.000+00:00',
                                    '2018-08-25T00:00:00.000+00:00',
                                    '2018-08-26T00:00:00.000+00:00',
                                ],
                            ],
                            fields: [
                                {
                                    name: 'foo',
                                },
                                {
                                    name: '_time',
                                },
                            ],
                        },
                        meta: {},
                    },
                }}
            />
        }
    />
);
